/** pdf-lib loads lazily on the first multi-document preview, not at boot. */
export async function mergePdfBase64(documents: string[]): Promise<string> {
  if (documents.length === 1) return documents[0];
  const { PDFDocument } = await import('pdf-lib');
  const merged = await PDFDocument.create();
  for (const base64 of documents) {
    const source = await PDFDocument.load(base64);
    const pages = await merged.copyPages(source, source.getPageIndices());
    for (const page of pages) merged.addPage(page);
  }
  return merged.saveAsBase64();
}
